import getters from './getters';
import actions from './actions';
import { defineStore } from "pinia"

function initState() {
    return {
        socialLinks: [],
        posts: [],
        pageNo: 0,
        hasMore: true
    };
}

export default (storeName) => defineStore(storeName, {
    state: initState,
    getters,
    actions
})
